@if (selected) {
  <div class="account-selector" [attr.data-test]="testPrefix + '-account-selector'">
    @if (hasChoice) {
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>{{ label }}</mat-label>
        <mat-select
          [value]="selected.monekId"
          (selectionChange)="onSelect($event)"
          [attr.data-test]="testPrefix + '-account-select'"
        >
          <mat-select-trigger>
            <span class="acct-id">{{ selected.monekId }}</span>
            @if (selected.acquirer) {
              <span class="acct-meta">· {{ selected.acquirer }}</span>
            }
          </mat-select-trigger>
          @for (option of options; track option.monekId) {
            <mat-option
              [value]="option.monekId"
              [disabled]="!option.isActive"
              [attr.data-test]="testPrefix + '-account-option-' + option.monekId"
            >
              <div class="acct-option">
                <div class="acct-option-main">
                  <span class="acct-id">{{ option.monekId }}</span>
                  @if (option.acquirer) {
                    <span class="acct-meta">{{ option.acquirer }}</span>
                  }
                </div>
                <div class="acct-tags">
                  @if (option.isOriginal) {
                    <span class="acct-tag acct-tag-original">Original</span>
                  }
                  @if (option.isPrimary) {
                    <span class="acct-tag acct-tag-primary">Primary</span>
                  }
                  @if (option.isTestMid) {
                    <span class="acct-tag">Test</span>
                  }
                  @if (!option.isActive) {
                    <span class="acct-tag acct-tag-closed">Closed</span>
                  }
                </div>
              </div>
            </mat-option>
          }
        </mat-select>
        <mat-hint>
          @if (selected.isOriginal) {
            The account the original payment was taken on.
          } @else {
            Different from the account the original payment was taken on.
          }
        </mat-hint>
      </mat-form-field>
    } @else {
      <div class="account-static" [attr.data-test]="testPrefix + '-account-static'">
        <span class="account-static-label">{{ label }}</span>
        <span class="account-static-value">
          <span class="acct-id">{{ selected.monekId }}</span>
          @if (selected.acquirer) {
            <span class="acct-meta">· {{ selected.acquirer }}</span>
          }
        </span>
      </div>
    }
  </div>
}
